import React from "react";
import { FormattedMessage } from "react-intl";

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="sort"
          data-sort="name"
          scope="col"
          onClick={() => props.applySort("name")}
        >
          <FormattedMessage id="components.pages.admin.groups.groupsTable.table.name" />
        </th>
        <th scope="row" className="w-10">
          <FormattedMessage id="components.pages.clients.clientsTable.table.actions" />
        </th>
      </tr>
    </thead>
  );
}

export { TableHead };
